require('./contractEasyLoanTypeCSummary.scss');

// @ vendor
const React = require('react');
const PropTypes = require('prop-types');
const classnames = require('classnames');
const { isEqual } = require('lodash/lang');
//@core
const { formatText } = require('core/i18n').i18n;
// @ components
const ContractLoanCompilationCard = require('../../contractLoanCompilationCard/contractLoanCompilationCard');

const ContractEasyLoanApproveTypeCTooltip = require('../contractEasyLoanApproveTypeCTooltip/contractEasyLoanApproveTypeCTooltip');

//@utilities
const { getFormattedString, formatCurrency, decimalsLength, formatAmount } = require('utilities/currencyHelper');
const { getLastNChars } = require('utilities/stringHelper');
// @constants
const { findPurposeById } = require('../../contractPayrollLoan/payrollLoanPurposes');

class ContractEasyLoanTypeCSummary extends React.Component {

    buildAccount() {
        const { alias, iban, balance } = this.props;
        const accountIban = getLastNChars(iban);
        const accountBalance = getFormattedString(balance);

        return [
            {
                label: formatText('payrollLoanCompilationCard-associatedAccount'),
                text: `${alias} ${accountIban}`,
                className: 'payroll-loan-compilation-card__list-separator'
            },

            {
                label: formatText('payrollLoanCompilationCard-accountBalance'),
                text: `${accountBalance}`
            }
        ];
    }

    buildFooterList() {
        const { immAccount, selectedAccount } = this.props;
        const openingCommission = this.buildOpeningCommission();

        let list = [
            openingCommission,
            {
                label: formatText('contractEasyLoanSidebar-openingCommissionAmortizacion'),
                additionalLabel: <sup>1</sup>
            }
        ];


        if (immAccount && selectedAccount !== '') {
            list = list.concat(this.buildAccount());
        }

        return list;
    }

    buildOpeningCommission() {
        const { immStep } = this.props;
        const rawArrangementFee = immStep.get('arrangementFee');
        const rawCurrency = immStep.get('currency');
        const toDefine = formatText('contractLoanCompilationCard-nodata');
        const currency = formatCurrency(rawCurrency);
        const arrangementPercentage = immStep.get('arrangementPercentage');
        const decimalsArragementFee = decimalsLength(rawArrangementFee);
        const arrangementFee = formatAmount(rawArrangementFee, decimalsArragementFee);

        return {
            label: formatText('payrollLoanCompilationCard-openingCommission', [arrangementPercentage]),
            text: arrangementFee ? `${arrangementFee} ${currency}` : toDefine,
        };
    }

    buildPurposeSection() {
        const { immStep, isDragoFeature } = this.props;

        if (!!immStep.get('selectedPurpose') || immStep.get('selectedPurposeDrago')) {
            let finalPurpose = findPurposeById(immStep.get('selectedPurpose'));
            let finalPurposeText = !!finalPurpose ? formatText(finalPurpose.text) : '';
            let finalPurposeIcon = !!finalPurpose ? finalPurpose.icon : '';

            if (isDragoFeature && !!immStep.get('newPurposesList')) {
                finalPurpose = immStep.get('newPurposesList').find(purposeElement => purposeElement.get('id') === immStep.get('selectedPurposeDrago'));
                finalPurposeText = !!finalPurpose ? finalPurpose.get('text') : finalPurpose;
                finalPurposeIcon = !!finalPurpose ? finalPurpose.get('icon') : null;
            }

            let content;
            const purposeIcon = classnames('icon', 'payroll-loan-compilation-card__icon', finalPurposeIcon);
            if (!!finalPurpose) {
                content = (
                    <div className="payroll-loan-compilation-card__purpose-section">
                        <i className={purposeIcon}></i>
                        {finalPurposeText}
                    </div>
                );
            }
            return content;
        }

    }

    buildTinTooltip() {
        const tooltipComp = (
            <div className={"contract-loan-compilation-card__tin-tooltip--body"}>
                {formatText("payrollLoanCompilationCard-tinTooltipText")}
            </div>
        );

        return {
            icon: 'icon-informacion',
            tooltipPlacement: 'top',
            tooltipClassName: 'contract-loan-compilation-card__tin-tooltip',
            iconCustomClass: 'contract-loan-compilation-card__tae-icon',
            tooltipOffset: [0, -10],
            information: tooltipComp
        };
    }
    buildTaeTooltip() {
        const { immContractEasyLoanTypeC } = this.props;
        return (
            <ContractEasyLoanApproveTypeCTooltip
                immContractEasyLoan={immContractEasyLoanTypeC}
                clarifyingText="clarifyingTextSidebar"
            />
        );
    }
    render() {
        const { immStep, showTinTooltip, immContractEasyLoanTypeC } = this.props;
        const footerList = this.buildFooterList();
        const taeTooltip = this.buildTaeTooltip();

        let tinTooltip = null;

        if (showTinTooltip && (immStep.get("userType") === 'TS')) {
            tinTooltip = this.buildTinTooltip();
        }

        return (
            <ContractLoanCompilationCard
                immSummary={immContractEasyLoanTypeC}
                taeTooltip={taeTooltip}
                footerList={footerList}
            />
        );
    }
}

ContractEasyLoanTypeCSummary.propTypes = {
    callKOxDTI: PropTypes.bool,
    isRequest: PropTypes.bool,
    immAccount: PropTypes.object,
    immStep: PropTypes.object.isRequired,
    isCollective: PropTypes.bool,
    isDragoFeature: PropTypes.bool,
    nodataKOxDTI: PropTypes.bool,
    setCurrentProductCollective: PropTypes.func,
    showTinTooltip: PropTypes.bool,
    taeTooltip: PropTypes.object
};

ContractEasyLoanTypeCSummary.defaultProps = {
    isRequest: false,
};

module.exports = ContractEasyLoanTypeCSummary;
